<template>
  <div class="page-container">
    <el-card shadow="never" class="page-card filter-card">
      <div class="filter-bar">
        <div class="filter-group">
          <el-select v-model="query.status" placeholder="全部状态" clearable class="filter-select-sm">
            <el-option label="待发货" :value="0" />
            <el-option label="已发货" :value="1" />
            <el-option label="已拒绝" :value="2" />
            <el-option label="已完成" :value="3" />
          </el-select>
          <el-input
            v-model="query.username"
            placeholder="用户名"
            prefix-icon="el-icon-user"
            clearable
            class="filter-input"
            @keyup.enter.native="handleSearch"
          />
          <el-input
            v-model="query.orderNo"
            placeholder="订单号"
            prefix-icon="el-icon-document"
            clearable
            class="filter-input"
            @keyup.enter.native="handleSearch"
          />
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        </div>
        <div class="action-group">
          <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && tableData.length === 0" description="暂无兑换订单" />

      <div v-else>
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          element-loading-text="加载中..."
          class="animate__animated animate__fadeIn"
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="60" align="center" />
          <el-table-column prop="orderNo" label="订单号" width="160" show-overflow-tooltip />
          <el-table-column prop="username" label="用户名" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="goodsName" label="商品名称" min-width="110" show-overflow-tooltip />
          <el-table-column prop="goodsImage" label="图片" width="70" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.goodsImage"
                :src="scope.row.goodsImage"
                fit="cover"
                lazy
                style="width:36px;height:36px;border-radius:4px;"
                :preview-src-list="[scope.row.goodsImage]"
              >
                <div slot="placeholder" class="img-placeholder"><i class="el-icon-loading"></i></div>
                <div slot="error" class="img-error"><i class="el-icon-picture-outline"></i></div>
              </el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalCoins" label="消耗金币" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.totalCoins != null ? scope.row.totalCoins : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="60" align="center" />
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="info" size="small">待发货</el-tag>
              <el-tag v-else-if="scope.row.status === 1" type="primary" size="small">已发货</el-tag>
              <el-tag v-else-if="scope.row.status === 2" type="danger" size="small">已拒绝</el-tag>
              <el-tag v-else-if="scope.row.status === 3" type="success" size="small">已完成</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="160" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="row-actions">
                <el-button type="text" size="mini" icon="el-icon-view" @click="openDetail(scope.row)">详情</el-button>
                <el-button
                  v-if="scope.row.status === 0"
                  type="text"
                  size="mini"
                  icon="el-icon-s-check"
                  @click="openAudit(scope.row)"
                >审核</el-button>
                <el-button v-if="scope.row.status !== 0" type="text" size="mini" icon="el-icon-delete" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      title="兑换订单详情"
      :visible.sync="detailVisible"
      width="560px"
      center
      append-to-body
    >
      <el-form v-if="detail" label-width="100px">
        <el-form-item label="订单号">
          <el-input :value="detail.orderNo || '-'" readonly />
        </el-form-item>
        <el-form-item label="用户名">
          <el-input :value="detail.username || '-'" readonly />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input :value="detail.goodsName || '-'" readonly />
        </el-form-item>
        <el-form-item label="商品图片">
          <el-image
            v-if="detail.goodsImage"
            :src="detail.goodsImage"
            fit="cover"
            style="width:80px;height:80px;border-radius:4px;"
            :preview-src-list="[detail.goodsImage]"
          />
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="消耗金币">
          <el-input :value="detail.totalCoins != null ? detail.totalCoins : '-'" readonly />
        </el-form-item>
        <el-form-item label="数量">
          <el-input :value="detail.quantity != null ? detail.quantity : '-'" readonly />
        </el-form-item>
        <el-form-item v-if="parseAddress(detail.addressSnapshot)" label="收货信息">
          <el-input :value="parseAddress(detail.addressSnapshot)" readonly type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="状态">
          <el-tag v-if="detail.status === 0" type="info">待发货</el-tag>
          <el-tag v-else-if="detail.status === 1" type="primary">已发货</el-tag>
          <el-tag v-else-if="detail.status === 2" type="danger">已拒绝</el-tag>
          <el-tag v-else-if="detail.status === 3" type="success">已完成</el-tag>
        </el-form-item>
        <el-form-item v-if="detail.auditRemark" label="审核备注">
          <el-input type="textarea" :value="detail.auditRemark" readonly :rows="2" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input :value="formatDate(detail.createdAt)" readonly />
        </el-form-item>
        <el-form-item v-if="detail.auditTime" label="审核时间">
          <el-input :value="formatDate(detail.auditTime)" readonly />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="审核兑换订单"
      :visible.sync="auditVisible"
      width="460px"
      center
      append-to-body
      @closed="onAuditClosed"
    >
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="100px">
        <el-form-item label="订单号">
          <el-input :value="auditForm.orderNo" readonly />
        </el-form-item>
        <el-form-item label="用户名">
          <el-input :value="auditForm.username" readonly />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input :value="auditForm.goodsName" readonly />
        </el-form-item>
        <el-form-item label="审核结果" prop="status">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">已发货</el-radio>
            <el-radio :label="2">已拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注">
          <el-input
            v-model.trim="auditForm.auditRemark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="选填"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取 消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, request, del } from '@/utils/http'
import { mallApi } from '@/api/mall'

export default {
  name: 'ExchangeOrderManagement',
  data() {
    return {
      loading: false,
      error: '',
      tableData: [],
      query: {
        status: null,
        username: '',
        orderNo: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      detailVisible: false,
      detail: null,
      auditVisible: false,
      auditLoading: false,
      auditForm: {
        id: null,
        orderNo: '',
        username: '',
        goodsName: '',
        status: 1,
        auditRemark: ''
      },
      auditRules: {
        status: [{ required: true, message: '请选择审核结果', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        if (this.query.status != null && this.query.status !== '') params.status = this.query.status
        if (this.query.username && this.query.username.trim()) params.username = this.query.username.trim()
        if (this.query.orderNo && this.query.orderNo.trim()) params.orderNo = this.query.orderNo.trim()

        const res = await get(mallApi.exchangeOrderPage, params)
        const data = res.data || {}
        this.tableData = Array.isArray(data.records) ? data.records : []
        this.pagination.total = typeof data.total === 'number' ? data.total : 0
        if (data.current) this.pagination.pageNum = data.current
      } catch (e) {
        console.error(e)
        this.error = e.message || '加载兑换订单失败'
        this.tableData = []
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchList()
    },
    refreshList() {
      this.query = { status: null, username: '', orderNo: '' }
      this.pagination.pageNum = 1
      this.fetchList()
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchList()
    },
    async openDetail(row) {
      this.detailVisible = true
      try {
        const res = await get(mallApi.exchangeOrderDetail(row.id))
        this.detail = res.data || row
      } catch (e) {
        this.detail = row
        this.$message.warning('拉取详情失败，已展示列表数据')
      }
    },
    openAudit(row) {
      this.auditForm = {
        id: row.id,
        orderNo: row.orderNo || '-',
        username: row.username || '-',
        goodsName: row.goodsName || '-',
        status: 1,
        auditRemark: ''
      }
      this.auditVisible = true
      this.$nextTick(() => this.$refs.auditForm && this.$refs.auditForm.clearValidate())
    },
    onAuditClosed() {
      this.auditLoading = false
    },
    submitAudit() {
      this.$refs.auditForm.validate(async valid => {
        if (!valid) return
        this.auditLoading = true
        try {
          const url = mallApi.exchangeOrderAudit(this.auditForm.id)
          const queryParams = new URLSearchParams()
          queryParams.set('status', this.auditForm.status)
          if (this.auditForm.auditRemark) queryParams.set('auditRemark', this.auditForm.auditRemark)
          await request(`${url}?${queryParams.toString()}`, { method: 'PUT' })
          this.$message.success('审核完成')
          this.auditVisible = false
          await this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '审核失败')
        } finally {
          this.auditLoading = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定永久删除订单号「${row.orderNo || row.id}」？不可恢复`, '提示', {
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      })
        .then(async () => {
          await del(mallApi.exchangeOrderDelete(row.id))
          this.$message.success('已删除')
          if (this.tableData.length === 1 && this.pagination.pageNum > 1) {
            this.pagination.pageNum -= 1
          }
          await this.fetchList()
        })
        .catch(() => {})
    },
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      if (Number.isNaN(d.getTime())) return String(val)
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    parseAddress(snapshot) {
      if (!snapshot) return ''
      try {
        const addr = typeof snapshot === 'string' ? JSON.parse(snapshot) : snapshot
        const parts = [addr.province, addr.city, addr.district, addr.detailAddress].filter(Boolean)
        const contact = [addr.receiverName, addr.phone].filter(Boolean).join(' / ')
        return [contact, parts.join(' ')].filter(Boolean).join('\n')
      } catch {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 16px;
}
.page-card {
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.filter-card {
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 18px;
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.filter-select-sm {
  width: 130px;
}
.filter-input {
  width: 190px;
}
.action-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.error {
  color: #f56c6c;
  padding: 24px;
  text-align: center;
}
.pagination-container {
  margin-top: 18px;
  padding: 4px 0;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.row-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
}
.row-actions .el-button--text {
  padding: 4px 6px;
}
.img-placeholder,
.img-error {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #dcdfe6;
  font-size: 14px;
}
</style>
